import Vue from 'vue';
import moment from 'moment';
import billsReportTransformer from './../../transformers/billsReport';

const success = ({ data }, resolve) => {
  const report = billsReportTransformer.fetchCollection(data.data);

  resolve(report);
};

const failed = (error, reject) => reject(error);


export default (dateRange, clientId = null, limit = null) => (
  new Promise((resolve, reject) => {
    let url = '/reports/bills';
    const query = [];

    if (clientId !== '') {
      query.push(`client_id=${clientId}`);
    }

    if (limit) {
      query.push(`limit=${limit}`);
    }

    if (dateRange[0] && dateRange[1]) {
      query.push(`start=${moment(dateRange[0]).format('YYYY-MM-DD')}`);
      query.push(`end=${moment(dateRange[1]).format('YYYY-MM-DD')}`);
    }

    if (query.length > 0) {
      url += '?';
      query.map((q) => {
        url += `${q}&`;
        return q;
      });
      url = url.substring(0, url.length - 1);
    }

    Vue.$http.get(url)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/bills.js